import * as React from "react";
import { Checkbox } from "../checkbox";

type Props = {
    label: string;
    value: boolean;
    disabled?: boolean;
    onChangeAction: (value: boolean) => any;
    description: string;
};

export const InlineEditCheckboxAdapter: React.FunctionComponent<Props> = props => {
    const { value, onChangeAction, description, label, disabled } = props;

    return (
        <Checkbox description={description} checked={value} onChange={onChangeAction} disabled={disabled}>
            {label}
        </Checkbox>
    );
};
